<template>
  <div class="container">
    <configure-header />
    <div
      v-show="(siteplusWebsiteDetails && !siteplusWebsiteDetails.domainName)"
      class="box"
    >
      <div class="is-size-2">
        {{ $t('assign_domain.unassigned') }}
      </div>
    </div>
    <div
      v-show="(siteplusWebsiteDetails && siteplusWebsiteDetails.domainName)"
      class="box"
    >
      <div class="is-size-3">
        {{ $t('assign_domain.current_domain') }} <span class="current-domain">{{ siteplusWebsiteDetails && siteplusWebsiteDetails.domainName }}</span>
      </div>
    </div>
    <div
      v-if="!hasRegisteredDomain"
      class="box"
    >
      <!-- link to existing register domain page, doesn't show if the user has already registered a domain -->
      <register-new-domain />
    </div>
    <div
      v-show="hasRegisteredDomain"
      class="box"
    >
      <!-- if the service has a domain registration (not sitePlus) then show the domain name registered -->
      <previous-domain />
    </div>
    <div class="box">
      <!-- already has an existing domain name, type in box to use (graphql mutation sitePlusWebsiteAssignDomainName on click) -->
      <existing-domain />
    </div>
    <div
      v-show="false"
      class="box"
    >
      <!-- can update DNS with their provider to transfer domain to us -->
      <dns-instructions />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfigureHeader from '@/components/DomainConfiguration/ConfigureHeader'
import RegisterNewDomain from '@/components/DomainConfiguration/RegisterNewDomain'
import PreviousDomain from '@/components/DomainConfiguration/PreviousDomain'
import ExistingDomain from '@/components/DomainConfiguration/ExistingDomain'
import DnsInstructions from '@/components/DomainConfiguration/DnsInstructions'
import generatedSiteplusUrlMixin from '@/mixins/siteplus-generated-urls'
import domainOverviewMixin from '@/mixins/domain-overview'

export default {
  name: 'ConfigureDomain',
  components: {
    ConfigureHeader,
    RegisterNewDomain,
    PreviousDomain,
    ExistingDomain,
    DnsInstructions
  },
  mixins: [generatedSiteplusUrlMixin, domainOverviewMixin],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('domainService', ['domainAllowedStatus', 'hasRegisteredDomain', 'hasPendingDomainSelection', 'hasPendingDomain'])
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/_variables.scss';
.box {
  padding: 25px 25px 30px 25px;
}
.current-domain {
  color: var(--primary-color);
  font-weight: bold;
}
</style>
